import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '@widgets/ui-common/material/material.module';
import { BatchProgressComponent } from './batch-progress.component';
import { SiteCommonModule } from '@widgets/site-common/site-common.module';
import { UiCommonModule } from '@widgets/ui-common/ui.common.module';

@NgModule({
  imports: [SiteCommonModule],
  declarations: [BatchProgressComponent],
  exports: [BatchProgressComponent]
})
export class BatchProgressModule {}
